import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { fluidScale, fluidShrink, respond } from '../../theme/mixins';
import { theme } from '../../constants';
import { Text } from '..';

function Template({ navigation, children }) {
  return (
    <article css={styles.wrapper}>
      <header css={styles.header}>
        <Text as="h3" intl="widget.title" className="interactive-widget__title" />
        <Text as="p" intl="widget.subtitle" className="interactive-widget__body" />
      </header>
      <aside css={styles.aside}>{navigation}</aside>
      <section css={styles.main}>{children}</section>
    </article>
  );
}

Template.propTypes = {
  navigation: PropTypes.node,
  children: PropTypes.node.isRequired,
};

const styles = {
  wrapper: css`
    display: grid;
    grid-template:
      'header .' auto
      'aside main' auto / ${fluidShrink(theme.sidebarMaxWidth)} minmax(0, 1fr);
    column-gap: ${fluidScale('80px', '32px')};
    row-gap: 2rem;
    padding: 2rem 2rem ${fluidScale('80px', '32px')};

    ${respond(`
      grid-template:
        'header .' auto
        'main main' auto
        'aside aside' auto / 2fr 1fr;
    `)}
  `,
  header: css`
    grid-area: header;
  `,
  aside: css`
    grid-area: aside;
    display: grid;
    align-content: start;
    grid-template-columns: 1fr;
    grid-gap: 1px;
  `,
  main: css`
    grid-area: main;
  `,
};

export default Template;
